module.exports = __webpack_public_path__ + "img/Rectangle 17.882c7cd2.png";